import {animate, style, transition, trigger} from "@angular/animations";
import {TBaseAnimationPayload} from "../../types";
import {DEFAULT_ANIMATION_PAYLOAD} from "../default-animation-config";

export const RIGHT_TO_LEFT_NOTIFICATION_SHOW
  = ({duration, timingFunction}: TBaseAnimationPayload = DEFAULT_ANIMATION_PAYLOAD) => trigger('rightToLeftNotificationShow', [
  transition(':enter', [
    style({right: '-15rem', opacity: 0}),
    animate(`${duration}s ${timingFunction}`, style({right: '0', opacity: 1}))
  ]),
  transition(':leave', [
    animate(`${duration}s ${timingFunction}`, style({right: '-15rem', opacity: 0}))
  ])
])
